<button type="button" class="btn btn-secondary--dark-blue btn-sm" [attr.data-test]="dataTest()">
  <i class="fas fa-pencil mr-2"></i>
  <span>{{ 'ummeldung.button.editInputs' | translate }}</span>
</button>
